import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {Description} from 'src/design/atoms/Description';
import {isValidObject} from 'src/utilities/objectUtils';
import {FormViewLabel} from '../FormViewLabel';
import classes from './FormViewRow.module.css';

export interface FormViewRowProps {
  label: string;
  valueColor?: string;
  // @TODO: Update typings.
  value: any;
  description?: string;
}
export const FormViewRow: React.FC<FormViewRowProps> = ({
  label,
  value,
  valueColor,
  description,
}) => {
  const displayValue = isValidObject(value) && value.label;
  return (
    <Box p={0} pt="xs" className={classes.wrapper}>
      <FormViewLabel>{label}</FormViewLabel>
      <Box
        className={`ql-editor ${classes.value}`}
        maw="100vw"
        c={valueColor ? valueColor : 'inherit'}>
        <>{displayValue || value}</>

        <Description text={description} />
      </Box>
    </Box>
  );
};
